import { render } from "./CardBlocking.vue?vue&type=template&id=69b10fb8"
import script from "./CardBlocking.vue?vue&type=script&lang=ts"
export * from "./CardBlocking.vue?vue&type=script&lang=ts"
script.render = render

export default script